import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { useHeaderRootStyles } from '../useHeaderRootStyles/useHeaderRootStyles.js';

var _excluded = ["isSticky", "isTransparent", "enableSafeArea"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useHeaderRoot = function useHeaderRoot(_ref) {
  var isStickyProp = _ref.isSticky,
    isTransparentProp = _ref.isTransparent,
    enableSafeAreaProp = _ref.enableSafeArea,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(!!isStickyProp),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isSticky = _React$useState2[0],
    setIsSticky = _React$useState2[1];
  var _React$useState3 = React.useState(!!isTransparentProp),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isTransparent = _React$useState4[0],
    setIsTransparent = _React$useState4[1];

  // This hook will return the styles based on the isSticky, isTransparent, and enableSafeArea props
  var headerRootStyles = useHeaderRootStyles(isSticky, isTransparent, !!enableSafeAreaProp);
  return {
    // There's no need to extract data- or aria- attributes separately from props, since they will already be spread at the container level anyways.
    headerContainerProps: _objectSpread(_objectSpread({}, headerRootStyles), props),
    contextValues: {
      isSticky: isSticky,
      setIsSticky: setIsSticky,
      isTransparent: isTransparent,
      setIsTransparent: setIsTransparent
    }
  };
};

export { useHeaderRoot };
//# sourceMappingURL=useHeaderRoot.js.map
